@if (settingKey.toLowerCase() === 'dateformat') {
    <span class="mb-1 text-xs text-gray-500">Example: {{ dateFormatExample }}</span>
    <app-control
        type="select"
        [options]="dateFormats"
        [isFilterable]="false"
        [(ngModel)]="settingValue"
        (ngModelChange)="updateDateFormatExample($event)" />
}
@if (timeFormat) {
    <span class="mb-1 text-xs text-gray-500">Example: {{ timeFormatExample }}</span>
    <app-control
        type="select"
        [options]="timeFormats"
        [isFilterable]="false"
        [(ngModel)]="settingValue"
        (ngModelChange)="updateTimeFormatExample($event)" />
}
